import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { canAccessBulkUpload, resolvePulseRoleName } from './utils/bulk-upload-access';
import { isTruthyRoleFlag } from './utils/bulk-upload-access';

/**
 * Requires PULSE login and bulk-upload role (Super Admin / Administrator).
 * Blocks direct navigation to `/bulk-upload` and `/bulk-upload-history` when the menu is hidden.
 */
export const bulkUploadGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  if (!localStorage.getItem('access_token')) {
    router.navigate(['login']);
    return false;
  }

  const roleDetailRaw = localStorage.getItem('role_detail');
  let roleDetail: any = null;
  try {
    roleDetail = roleDetailRaw ? JSON.parse(roleDetailRaw) : null;
  } catch {
    roleDetail = null;
  }

  const url = String(state.url || '');
  const wantsInsert = url.includes('/bulk-upload') && !url.includes('/bulk-upload-history');
  const wantsHistory = url.includes('/bulk-upload-history');

  const insertAllowed = isTruthyRoleFlag(roleDetail?.is_bulk_insert_visible);
  const historyAllowed = isTruthyRoleFlag(roleDetail?.is_bulk_history_visible);

  // Backward compatibility: if flags are missing, fall back to old super/admin rule.
  const anyFlagPresent = [
    roleDetail?.is_bulk_insert_visible,
    roleDetail?.is_bulk_history_visible,
  ].some(v => v != null);

  const roleName = resolvePulseRoleName();
  const legacyAllowed = canAccessBulkUpload(roleName);

  const allowed = anyFlagPresent
    ? (wantsInsert ? insertAllowed : wantsHistory ? historyAllowed : false)
    : legacyAllowed;

  if (!allowed) {
    router.navigate(['home']);
    return false;
  }
  return true;
};
